import React from 'react'

import idx from 'idx'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import TitleWithLabel from 'components/atoms/TitleWithLabel'
import ChangePercentage from 'components/atoms/ChangePercentage'

import { formatDate, LOCAL_DATE_FORMAT_MONTH } from 'utils/date'

const styles = theme => ({
  root: {
    padding: theme.spacing(6),
    animation: 'fadeIn .6s ease',
  },
  section: {
    display: 'flex',
    position: 'relative',
    padding: theme.spacing(4),
    justifyContent: 'space-around',
    boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
  },
  smallSection: {
    padding: theme.spacing(4),
  },
  stat: {
    padding: 0,
    fontFamily: 'Bebas, Lato',
  },
  divider: {
    width: 1,
    backgroundColor: theme.palette.background.medium,
  },
  percentage: {
    top: 12,
    right: 20,
    position: 'absolute',
  },
})

const OverviewStats = ({ classes, data }) => {
  const monthData = idx(
    data,
    _ =>
      _.organisationOverviewDetails && _.organisationOverviewDetails.slice(-2)
  )

  if (monthData) {
    const currentMonth = formatDate(monthData[1].date, LOCAL_DATE_FORMAT_MONTH)
    const syncedTraps = `${monthData[1].totalTrapsSynced}/${monthData[1].totalTraps}`
    const currentMonthKills = `${monthData[1].totalKills}`

    return (
      monthData &&
      monthData.length > 1 && (
        <div className={classes.root}>
          <Grid container spacing={10}>
            <Grid item md={6}>
              <div className={classes.section}>
                <TitleWithLabel
                  className={classes.stat}
                  title={syncedTraps}
                  label={`${currentMonth}'s traps synced`}
                />
                <div className={classes.divider} />
                <TitleWithLabel
                  className={classes.stat}
                  title={currentMonthKills}
                  label={`${currentMonth}'s kills`}
                />
                <ChangePercentage
                  className={classes.percentage}
                  old={monthData[0].totalKills}
                  current={monthData[1].totalKills}
                />
              </div>
            </Grid>
            <Grid item md={6}>
              <div className={classes.section}>
                <TitleWithLabel
                  className={classes.stat}
                  title={data.totalKills}
                  label="Total kills (12 months)"
                />
                <div className={classes.divider} />
                <TitleWithLabel
                  className={classes.stat}
                  title={data.totalTraps}
                  label="Total traps"
                />
                <div className={classes.divider} />
                <TitleWithLabel
                  className={classes.stat}
                  title={data.totalViewers}
                  label="Total contributors"
                />
              </div>
            </Grid>
          </Grid>
        </div>
      )
    )
  }
  return null
}

OverviewStats.propTypes = {
  data: PropTypes.object,
  classes: PropTypes.object,
}

export default withStyles(styles)(OverviewStats)



// WEBPACK FOOTER //
// ./src/components/organisms/Overview/Stats.js